import {
  FETCH_PRIZE_SUCCEED,
  FETCH_LUCKY_GAME_CONFIG_SUCCEED,
} from '../actions/prize/action_types';

export default (
  state = {
    prizes: [],
    config: {},
    configPrizes: [],
  },
  action,
) => {
  switch (action.type) {
    case FETCH_PRIZE_SUCCEED:
      return {
        ...state,
        prizes: action.data,
      };
    case FETCH_LUCKY_GAME_CONFIG_SUCCEED:
      return {
        ...state,
        config: action.data,
        configPrizes: action.data.configs.list_prize,
      };
    default:
      return {
        ...state,
      };
  }
};
